<template>
    <div style="background-color: #F9F9FB;width:100%">
        <div class="personal">
            <div class="menu">
                <div class="menu-item" v-for="(item, index) in list" :key="index"
                    @click="e => { handleActice(e, item.type, item.path,index) }">
                    <div :class="[item.type == actType ? 'flexa-bac' : '', 'flexa']">
                        <img  @dragstart.prevent  :src="item.type == actType ? item.imgSele : item.img" class="icon" alt="" />
                        <p>{{ item.name }}</p>
                        <img  @dragstart.prevent  v-if="item.type == 0 && miniMenuShow" :src="shouqi" alt="" class="icon2">
                        <img  @dragstart.prevent  v-if="item.type == 0 && !miniMenuShow" :src="zhankai" alt="" class="icon2">
                    </div>
                    <div v-if="item.miniMenu && miniMenuShow" class="miniMenu">
                        <div class="miniMenu-item" v-for="(item, index) in item.miniMenu" :key="index"
                            @click="e => { handleActiceMin(e, item.type,item.path) }">
                            <p :class="[item.type == miniMenuAct ? 'item-act' : '',]">{{ item.name }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="meunContent">
                <router-view v-slot="{ Component }" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { useRoute, useRouter } from 'vue-router'
import { navTo } from '../utils/utils'
import zhankai from '../assets/icon_xiala.png'
import shouqi from '../assets/icon_shouqi.png'
let list = ref([
    // { type: 24, img: require('../assets/icon_wdqb.png'), imgSele: require('../assets/icon_selected_wdqb.png'), name: '我的钱包', path: 'personalCenter' },
    // { type: 22, img: require('../assets/icon_gkls.png'), imgSele: require('../assets/icon_selected_gkls.png'), name: '观看历史', path: 'personalCenter' },
    // { type: 23, img: require('../assets/icon_scjz.png'), imgSele: require('../assets/icon_selected_scjz.png'), name: '收藏记录', path: 'personalCenter' },
    { type: 4, img: require('../assets/icon_jyjl.png'), imgSele: require('../assets/icon_selected_jyjl.png'), name: '交易记录', path: 'personalCenter' },
    {
        type: 0, img: require('../assets/icon_yhxy.png'), imgSele: require('../assets/icon_selected_yhxy.png'), name: '用户协议', path: 'userAgreement', miniMenu: [
            { type: 5, name: '用户服务协议', path: 'userAgreement' },
            { type: 6, name: '隐私政策', path: 'userAgreement' },
            { type: 7, name: '退款中心' , path: 'userAgreement'},
            // { type: 8, name: '退款协议', path: 'userAgreement' },
            { type: 9, name: '自审制度' , path: 'userAgreement'},
            { type: 10, name: '用户纠纷处理', path: 'userAgreement' },
            { type: 11, name: '未成年保护制度', path: 'userAgreement' },
        ]
    },
    { type: 13, img: require('../assets/icon_gywm.png'), imgSele: require('../assets/icon_selected_gywm.png'), name: '关于我们', path: 'personalCenter' },
    { type: 14, img: require('../assets/icon_lxwm.png'), imgSele: require('../assets/icon_selected_lxwm.png'), name: '联系我们', path: 'personalCenter' },
])
let route = useRoute()
let router = useRouter()
let actType = ref(route.query.id)
let handleActiceMin = ((e, val,p) => {
    e.stopPropagation()
    // console.log(e, val, '看看用户协议');
    miniMenuAct.value = val
    let path=p
    let query = { id: 0,miniID:val }
    navTo(path, query)
})
let handleActice = ((e, val, p,ind) => {
    e.stopPropagation()
    actType.value = val
    let path = p
    let query = { id: val } 
    if (val == 0) {  //用户协议
        miniMenuAct.value = 5
        miniMenuShow.value = !miniMenuShow.value
        query = { id: 0,miniID:miniMenuAct.value }
    } else {
        miniMenuAct.value = 0
        miniMenuShow.value = false
    }

    navTo(path, query)
})
let miniMenuAct = ref(0)
let miniMenuShow = ref(false)
watch(() => route.query,
    (val) => {
        actType.value = val.id;
        if(val.open){
            miniMenuAct.value = val.miniID
            miniMenuShow.value = true
        }
        // if(val.id == 0){
        //     miniMenuAct.value = 5
        //     miniMenuShow.value = true
        // }else{
        //     miniMenuAct.value = 0
        //     miniMenuShow.value = false
        // }
    })


</script>

<style lang="scss" scoped>
.personal {
    width: 1188px;
    margin: 0 auto;
    padding: 40px 0 108px;
    display: flex;

    .menu {
        width: 200px;
        padding: 10px;
        background-color: #fff;
        border-radius: 10px;
        margin-right: 30px;


        &-item {
            margin: 10px 0;
            // padding: 6px 10px;
            font-size: 16px;
            color: #333333;
            line-height: 24px;
            cursor: pointer;

            img {
                width: 20px;
                height: 20px;
                margin-right: 5px;
            }

            .miniMenu {
                display: flex;
                flex-direction: column;
                padding-left: 25px;

                &-item {
                    padding: 7px 0;
                    box-sizing: border-box;

                    .item-act {
                        color: #CB2945;
                    }
                }
            }
        }
    }

    .meunContent {
        width: 958px;
        // height: 812px;
        background: #FFFFFF;
        border-radius: 10px;
    }

    .flexa {
        display: flex;
        align-items: center;
        padding: 6px 10px;
        background: #FFFFFF;
        width: 100%;
        position: relative;
        .icon2 {
            width: 16px;
            height: 16px;
            position: absolute;
            right: 0;
        }
    }

    .flexa-bac {
        border-radius: 6px;
        background: rgba(203, 41, 69, 0.06);
    }
}</style>